import { H2, H4, P2 } from '@zooplus/ui-components';
import { useTranslation } from '../../../hooks/use-translations';
import React from 'react';
import styles from './TotalSavings.module.scss';
import { useSiteContext } from '@zooplus/commons-lang';
import { Savings } from '@zooplus/icons';

interface TotalSavingsProps {
  totalSavingsFormatted: string;
  savingsSince: Date;
}

export const TotalSavings = (props: TotalSavingsProps) => {
  const { t } = useTranslation();
  const { locale } = useSiteContext();
  const yearMonth = props.savingsSince.toLocaleString(locale, {
    month: 'long',
    year: 'numeric',
  });
  return (
    <section className={styles.wrapper} data-testid="TotalSavings">
      <div className={styles.titleBox}>
        <Savings />
        <H4 className={styles.title}>{t('upcoming-subscriptions.total-savings.title')}</H4>
      </div>
      <div className={styles.contentBox}>
        <P2 className={styles.savingsSince}>
          {t('upcoming-subscriptions.total-savings.since')} {yearMonth}
        </P2>
        <H2 className={styles.totalSavings}>{props.totalSavingsFormatted}</H2>
      </div>
    </section>
  );
};
